import { Link } from "react-router-dom";
import { ArrowRight, Boxes } from "lucide-react";

import EmptyState from "@/components/layout/EmptyState";
import PageHeader from "@/components/layout/PageHeader";
import { Button } from "@/components/ui/button";

export default function AssetSectionPlaceholderPage({
  title,
}: {
  title: string;
}) {
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Asset library"
        title={title}
        description="Route này đã được dựng sẵn trong shell nhưng chưa có workflow dữ liệu tương ứng."
      />

      <EmptyState
        icon={<Boxes className="h-6 w-6" />}
        title={`${title} chưa được triển khai`}
        description="Để giữ shell nhất quán, route đã có sẵn nhưng phần data contract, preview và pricing workflow cho asset type này vẫn chưa được mở."
        actions={
          <Button asChild variant="outline">
            <Link to="/assets/clothes">
              Quay lại Clothes
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        }
      />
    </div>
  );
}
